import React from 'react'
import { reviewPath } from '../../routes/path'
import PropTypes from 'prop-types'

export interface AgencyUserLockedProps {
  supportEmail: string
}

const AgencyUserLocked: React.FC<AgencyUserLockedProps> = (props) => {
  return (
    <div className='modal-top'>
      <div className='header pro-head-5' role='heading'>Your account is not yet approved.</div>
      <p className='message'>
        We will notify you when this one-time approval process is complete (typically within 1 business day).
        Once approved, you'll have access to all the perks and features of being a verified Procurated user.
        Meanwhile, you can write a review or continue to peruse the list of suppliers.
      </p>

      <hr />

      <div className='text-center write-a-review'>
        <a href={reviewPath()} className='button pro-button pro-large'>Write a Review</a>

        <div className='clearfix' />
      </div>

      <p className='text-center'>
        Questions? <a href={`mailto:${props.supportEmail}`} className='underline'>Contact Support</a>
      </p>
    </div>
  )
}

AgencyUserLocked.propTypes = {
  supportEmail: PropTypes.string.isRequired
}

export default AgencyUserLocked
